import React from "react";
import ReactToPrint from "react-to-print";
import { NumericFormat } from 'react-number-format';
import { MDBTable, MDBTableBody, MDBTableHead } from 'mdbreact';


class ComponentToPrint extends React.Component {
  render() {
    const cierre = this.props.cierre

    console.log("cierre", cierre.ventasUsuarios)

    return (
      <div className="cont_tiket">
        <hr className="lineaFactura" />
        <h5>CIERRE DE CAJA {cierre.tipo}</h5>
        <h4>Blue Moon Beauty SD INC</h4>
        <hr className="lineaFactura" />

        <span>CIERRE DE CAJA #{this.props.consecutivo}</span><br />
        <span>Realizado por: {cierre.usuario}</span><br />
        <span>Fecha y hora: {cierre.fecha}</span><br />
        <hr className="lineaFactura" />


        <span>RESÚMEN:</span><br />

        <MDBTable responsive>
          <MDBTableBody>
            {cierre.modo === 'completo' ?
              <tr className="tabla_tiquete">
                <td></td>
                <td>VENTAS BRUTAS:</td>
                <td><NumericFormat decimalScale={2} value={cierre.ventasBrutas + cierre.totalDescPersonali} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}
            {cierre.modo === 'completo' ?
              <tr className="tabla_tiquete">
                <td>{cierre.pedidosCredito}</td>
                <td>VENTAS CREDITO:</td>
                <td><NumericFormat decimalScale={2} value={cierre.totalPedidosCredito} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}
            {cierre.modo === 'completo' ?
              <tr className="tabla_tiquete">
                <td>{cierre.descPersonali}</td>
                <td>DESCUENTO:</td>
                <td><NumericFormat decimalScale={2} value={cierre.totalDescPersonali} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}
            {cierre.modo === 'completo' ?
              <tr className="tabla_tiquete">
                <td>{cierre.pedidosActivos}</td>
                <td>VENTAS BRUTAS:</td>
                <td><NumericFormat decimalScale={2} value={cierre.ventasBrutas + cierre.totalDescPersonali} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}

            {cierre.modo === 'completo' ?
              <tr className="tabla_tiquete">
                <td>{cierre.pedidosActivos}</td>
                <td>VENTAS NETAS:</td>
                <td><NumericFormat decimalScale={2} value={cierre.totalPedidosActivos + cierre.totalPedidosCredito} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}







            {cierre.modo === 'parcial' ?
              <tr className="tabla_tiquete">
                <td>{cierre.pedidosActivos}</td>
                <td>VENTAS NETAS:</td>
                <td><NumericFormat decimalScale={2} value={cierre.totalPedidosActivos} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}

            {cierre.modo === 'parcial' ?
              <tr className="tabla_tiquete">
                <td>{cierre.pedidosActivos}</td>
                <td>VENTAS DE CONTADO:</td>
                <td><NumericFormat decimalScale={2} value={cierre.totalPedidosActivos} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
              </tr>
              : null}

          </MDBTableBody>
        </MDBTable>


        {cierre.modo === 'parcial' ?

          <div>
            <hr className="lineaFactura" />
            <MDBTable responsive>
              <MDBTableBody>
                <tr className="tabla_tiquete">
                  <td>{cierre.descPersonali}</td>
                  <td>DESCUENTO:</td>
                  <td><NumericFormat decimalScale={2} value={cierre.totalDescPersonali} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                </tr>
              </MDBTableBody>
            </MDBTable>
          </div>
          : null}


        <hr className="lineaFactura" />

        <MDBTable responsive>
          <MDBTableBody>

            <tr className="tabla_tiquete">
              <td>{cierre.pedidosCancel}</td>
              <td>VENTAS CANCELADAS:</td>
              <td><NumericFormat decimalScale={2} value={cierre.totalPedidosCancel} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
            </tr>

          </MDBTableBody>
        </MDBTable>
        <hr className="lineaFactura" />

        {cierre.modo === 'completo' ?
          <div>
            <span>VENTAS POR USUARIOS:</span><br />
            <MDBTable responsive>
              <MDBTableBody>
                {cierre.ventasUsuarios.map((item, index) => (
                  <tr className="tabla_tiquete">
                    <td>{item.cantidad}</td>
                    <td>{item?.nombre ? item.nombre : 'Página o App'}</td>
                    <td><NumericFormat decimalScale={2} value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                  </tr>
                ))}

                <tr className="tabla_tiquete">
                  <td></td>
                  <td>TOTAL:</td>
                  <td><NumericFormat decimalScale={2} value={cierre.totalPedidosActivos + cierre.totalPedidosCredito} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                </tr>

              </MDBTableBody>
            </MDBTable>
            <hr className="lineaFactura" />
          </div>
          : null}


        {cierre.modo === 'completo' ?
          <div>
            <span>VENTAS POR PRODUCTOS:</span><br />
            <MDBTable responsive>
              <MDBTableBody>
                {cierre.ventasProduct.map((item, index) => (
                  <tr className="tabla_tiquete">
                    <td>{item.cantidad}</td>
                    <td>{item.nombre}</td>
                    <td><NumericFormat decimalScale={2} value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                  </tr>
                ))}

                <tr className="tabla_tiquete">
                  <td></td>
                  <td>TOTAL: VENTAS NETAS</td>
                  <td><NumericFormat decimalScale={2} value={cierre.totalPedidosActivos + cierre.totalPedidosCredito} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                </tr>

              </MDBTableBody>
            </MDBTable>
            <hr className="lineaFactura" />
          </div>
          : null}


        {cierre.modo === 'completo' ?
          <div>
            <span>VENTAS POR MEDIO DE PAGO:</span><br />
            <MDBTable responsive>
              <MDBTableBody>
                {cierre.ventasMedios.map((item, index) => (
                  <tr className="tabla_tiquete">
                    <td>{item.cantidad}</td>
                    <td>{item.nombre}</td>
                    <td><NumericFormat decimalScale={2} value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                  </tr>
                ))}

                <tr className="tabla_tiquete">
                  <td></td>
                  <td>TOTAL:</td>
                  <td><NumericFormat decimalScale={2} value={cierre.totalPedidosActivos + cierre.totalPedidosCredito} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                </tr>

              </MDBTableBody>
            </MDBTable>
            <hr className="lineaFactura" />
          </div>
          : null}


        {cierre.modo === 'completo' ?
          <div>
            <span>DESCUENTOS:</span><br />
            <MDBTable responsive>
              <MDBTableBody>
                {cierre.descPer.map((item, index) => {
                  if (item.total > 0) {
                    return (
                      <tr className="tabla_tiquete">
                        <td>{item.cantidad}</td>
                        <td>{item.nombre}</td>
                        <td><NumericFormat decimalScale={2} value={item.total} displayType={'text'} thousandSeparator={true} prefix={'$'} /></td>
                      </tr>
                    )
                  }
                }
                )}
              </MDBTableBody>
            </MDBTable>
            <hr className="lineaFactura" />
          </div>
          : null}

      </div>
    );
  }
}

class ImpresionCierre extends React.Component {

  render() {
    return (
      <div>
        <ReactToPrint
          trigger={() =>
            <a href="#"
              className="btn boton_estandar"
            >Imprimir Ticket
            </a>}
          content={() => this.componentRef}
        />
        <ComponentToPrint
          ref={el => (this.componentRef = el)}
          cierre={this.props.cierre}
          consecutivo={this.props.consecutivo} />
      </div>
    );
  }
}

export default ImpresionCierre;
